import React from 'react';
import Icon from './Icon';
import { scrollToId } from '../utils/scroll';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div className="footer-col footer-brand">
          <a href="#hero" className="logo" onClick={(e) => { e.preventDefault(); scrollToId('hero'); }}>
            <span className="logo-mark">BT</span>
            <span className="logo-text">Buildstrust<span>IT Consultants</span></span>
          </a>
          <p>Helping businesses work smarter, grow faster, and achieve measurable results through innovative IT and automation solutions.</p>
          <div className="social-links">
            <a href="https://www.linkedin.com/company/buildstrust" aria-label="LinkedIn"><Icon name="linkedin" size={18} /></a>
            <a href="https://x.com/BuildsTrust_AI" aria-label="Twitter"><Icon name="twitter" size={18} /></a>
            {/* <a href="#hero" aria-label="Facebook"><Icon name="facebook" size={18} /></a> */}
            {/* <a href="#hero" aria-label="Instagram"><Icon name="instagram" size={18} /></a> */}
          </div>
        </div>

        <div className="footer-col">
          <h4>Quick Links</h4>
          <button onClick={() => scrollToId('services')}>Services</button>
          <button onClick={() => scrollToId('benefits')}>Benefits</button>
          <button onClick={() => scrollToId('industries')}>Industries</button>
          <button onClick={() => scrollToId('about')}>About Us</button>
        </div>

        <div className="footer-col">
          <h4>Services</h4>
          <button onClick={() => scrollToId('services')}>Managed IT Services</button>
          <button onClick={() => scrollToId('services')}>Business Process Automation</button>
          <button onClick={() => scrollToId('services')}>Digital Transformation</button>
          <button onClick={() => scrollToId('services')}>Go-To-Market Enablement</button>
        </div>

        <div className="footer-col">
          <h4>Resources</h4>
          <button onClick={() => scrollToId('case-studies')}>Case Studies</button>
          <button onClick={() => scrollToId('roi-calculator')}>ROI Calculator</button>
          {/* <button onClick={() => scrollToId('contact')}>Contact</button> */}
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <span 
           className="footer-contact"><Icon name="mail" size={16} /> <a href="mailto:info@buildstrust.com" > info@buildstrust.com  </a>
          </span>
          <span className="footer-contact"><Icon name="phone" size={16} /> +1 (925) 315-9125</span>
          <span className="footer-contact"><Icon name="map-pin" size={16} /> Tracy, CA, USA</span>
          <span className="footer-contact"><Icon name="map-pin" size={16} /> New Jersey, NJ, USA</span>
    
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {year} Buildstrust. All rights reserved.</p>
      </div>
    </footer>
  );
}